import { StyledMaxWidth } from '$shared/components/max-width';
import { theme } from '$theme';
import styled from '@emotion/styled';

export const StyledComparePage = styled(StyledMaxWidth)(() => ({
    paddingTop: theme.space[6],
    paddingBottom: theme.space[7],
}));